<template>
  <div class="onebox">
    <drag-modal :visible="$store.state.dislog.Six" @cancel="reset" :title="'添加进度-' + litetit" :class="{ editbox: Edit }"
      width="860px">
      <div class="navbox" v-if="Edit">
        <Nscroll @getIndex="see" @delCopy="copydel" :openEdit="openEdit"></Nscroll>
        <div class="intopbtn" v-if="!isAllDis">
          <!-- <a-popconfirm title="确认新增此进度吗?" ok-text="确定" cancel-text="取消" @confirm="copyNew">
            <a-button icon="plus" v-if='!openEdit'>新增本进度</a-button>
          </a-popconfirm> -->
          <a-popconfirm title="确认删除当前进度吗?" ok-text="确定" cancel-text="取消" @confirm="delStep" v-if="
            step != 181 && $store.state.DisForm.infoList &&
            $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.del)
          ">
            <a-button type="danger" icon="delete" style="margin-left: 12px">删除</a-button>
          </a-popconfirm>
          <a-button icon="edit" v-if="
            $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.edit) &&
            $store.getters.publicPower
          " style="margin-left: 10px" @click="openEdit = !openEdit">{{ openEdit ? '修改' : '取消修改' }}</a-button>
        </div>
      </div>
      <a-spin :spinning="loading">
        <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 10 }" :wrapper-col="{ span: 24 }"
          labelAlign="left">
          <div class="fourlist">
            <a-form-model-item label="文书类型" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }"
              :rules="{ required: true, message: '请选择文书类型', trigger: 'change', }">
              <!-- <a-button icon="plus" class="mr20" @click='plusAdd(1)' :type="form.list[0].disabled?'primary':''">判决书</a-button>
              <a-button icon="plus" class="mr20" @click='plusAdd(2)' :type="form.list[1].disabled?'primary':''">调解书</a-button>
              <a-button icon="plus" class="mr20" @click='plusAdd(3)' :type="form.list[2].disabled?'primary':''">裁定书</a-button>
              <a-button icon="plus" class="mr20" @click='plusAdd(4)' :type="form.list[3].disabled?'primary':''">调解协议</a-button>
              <a-button icon="plus" class="mr20" @click='plusAdd(5)' :type="form.list[4].disabled?'primary':''">撤诉申请</a-button> -->
              <a-radio-group v-model="form.type" :disabled="openEdit" v-if="step != 63">
                <a-radio :value="1">判决书</a-radio>
                <a-radio :value="2">调解书</a-radio>
                <a-radio :value="5">撤诉裁定</a-radio>
                <a-radio :value="3">其他裁定</a-radio>
                <!-- 调解书、司法确认、公证文书、调解协议、撤回申请、退回文书、其他文书 -->
                <!-- <a-radio :value="4">撤诉申请</a-radio> -->
              </a-radio-group>
              <a-radio-group v-model="form.type" :disabled="openEdit" v-else>
                <a-radio :value="2">调解书</a-radio>
                <a-radio :value="6">司法确认</a-radio>
                <a-radio :value="7">公证文书</a-radio>
                <a-radio :value="4">调解协议</a-radio>
                <a-radio :value="8">撤回申请</a-radio>
                <a-radio :value="9">退回文书</a-radio>
                <a-radio :value="10">其他文书</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <div>
              <div class="cmainbox">
                <div class="blax">
                  <div class="dul">
                    <div class="li">
                      <div class="tipt">
                        {{ form.type | rClaTit }}
                      </div>
                      <a-row :gutter="24">
                        <a-col :span="8">
                          <a-form-model-item label="材料名称" prop="filename"
                            :rules="{ required: true, message: '请输入材料名称', trigger: 'blur', }">
                            <a-input v-model="form.filename" :placeholder="!openEdit ? '请输入材料名称' : ''"
                              :disabled="openEdit" />
                          </a-form-model-item>
                        </a-col>
                        <!-- <a-col :span="8" v-if='i.type>3'>
                          <a-form-model-item label="寄出时间" :prop="'list.' + index + '.time'" :rules="{ required: false, message: '请选择时间',trigger: 'change'}">
                            <a-date-picker v-model="i.time" placeholder="请选择" format='YYYY-MM-DD HH:mm:ss' type="date" valueFormat="YYYY-MM-DD HH:mm:ss" :disabled='openEdit' style="width:100%;" />
                          </a-form-model-item>
                        </a-col> -->
                        <a-col :span="8">
                          <a-form-model-item label="签收时间" :rules="{ required: false }">
                            <a-date-picker v-model="form.receive_time" :placeholder="!openEdit ? '请选择签收时间' : ''"
                              format="YYYY-MM-DD HH:mm:ss" type="date" valueFormat="YYYY-MM-DD HH:mm:ss"
                              :disabled="openEdit" style="width: 100%" />
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-model-item label="单号" :rules="{
                            required: false,
                            message: '请输入单号',
                            trigger: 'blur',
                          }">
                            <a-input v-model="form.ship_no" :placeholder="!openEdit ? '请输入单号' : ''"
                              :disabled="openEdit" />
                          </a-form-model-item>
                        </a-col>
                      </a-row>
                      <a-row>
                        <a-form-model-item label="备注" :label-col="{ span: 10 }" :wrapper-col="{ span: 24 }" :rules="{
                          required: false,
                          message: '请输入文书摘要',
                          trigger: 'change',
                        }">
                          <Textarea :content="form.content" @contentVal="
                            (element) => {
                              form.content = element
                            }
                          " :edit="openEdit" :keyArr="['time', 'user']">
                          </Textarea>
                        </a-form-model-item>
                      </a-row>
                    </div>
                  </div>
                </div>
              </div>
              <a-form-model-item label="文书生效时间" :label-col="{ span: 3 }" :wrapper-col="{ span: 7 }"
                v-if='step == 60 || step == 63' prop="judgment_valid_time"
                :rules="{ required: true, message: '请选择文书生效时间', trigger: 'change', }" style="padding-bottom: 20px">
                <a-date-picker v-model="form.judgment_valid_time" placeholder="请选择文书生效时间" show-time type="date"
                  valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                  style="width: 100%;margin-left: 20px;" />
              </a-form-model-item>
            </div>
            <div>
              <div class="licter" v-if='!openEdit'>
                <label>补充材料:</label>
                <div class="rmain">
                  <a href="javascript:void(0);" @click="plusAdd(1)">电子</a>
                  <a href="javascript:void(0);" @click="plusAdd(2)">微信</a>
                  <a href="javascript:void(0);" @click="plusAdd(3)">现场</a>
                  <a href="javascript:void(0);" @click="plusAdd(4)">邮寄</a>
                </div>
              </div>
              <div class="ilikecon">
                <div class="ilikebox" v-for='(i, index) in form.supp' :key='index'>
                  <div class="likebox" v-if='i.type == 1'>
                    <div class="htit">补充材料：电子
                      <span @click='del(index)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="平台名称" :prop="'supp.' + index + '.platform'"
                          :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }">
                          <a-input v-model="i.platform" :disabled='openEdit' placeholder="请输入平台名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'"
                          :rules="{ required: true, message: '请选择补充时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="24">
                      <a-col :span='24'>
                        <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="likebox" v-if='i.type == 2'>
                    <div class="htit">补充材料：微信
                      <span @click='del(index)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="对方微信号" :prop="'supp.' + index + '.wx'"
                          :rules="{ required: true, message: '请输入对方微信号', trigger: 'blur' }">
                          <a-input v-model="i.wx" :disabled='openEdit' placeholder="请输入对方微信号" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'"
                          :rules="{ required: true, message: '请选择补充时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span='24'>
                        <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注"  />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="likebox" v-if='i.type == 3'>
                    <div class="htit">
                      补充材料：现场
                      <span @click='del(index)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="补充提交人" :prop="'supp.' + index + '.submiter'"
                          :rules="{ required: true, message: '请输入补充提交人', trigger: 'blur' }">
                          <a-input v-model="i.submiter" :disabled='openEdit' placeholder="请输入补充提交人" />
                        </a-form-model-item>
                      </a-col>

                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'"
                          :rules="{ required: true, message: '请选择补充时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span='24'>
                        <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注"  />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="likebox" v-if='i.type == 4'>
                    <div class="htit">
                      补充材料：邮寄
                      <span @click='del(index)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="单号" :prop="'supp.' + index + '.ship_no'"
                          :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                          <a-input v-model="i.ship_no" :disabled='openEdit' placeholder="请输入单号" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' placeholder="请输入" />
                      </a-form-model-item> -->
                        <a-form-model-item label="联系方式" :prop="'supp.' + index + '.tel'"
                          :rules="{ required: true, message: '请输入联系方式', trigger: 'blur' }">
                          <a-input v-model="i.tel" :disabled='openEdit' placeholder="请输入联系方式" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="收件人" :prop="'supp.' + index + '.receive_name'"
                          :rules="{ required: true, message: '请输入收件人', trigger: 'blur' }">
                          <a-input v-model="i.receive_name" :disabled='openEdit' placeholder="请输入收件人" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="寄出时间" :prop="'supp.' + index + '.ship_time'"
                          :rules="{ required: true, message: '请选择寄出时间', trigger: 'change' }">
                          <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="">
                          <label v-if='openEdit'>{{ i.gout == "a" ? "签收时间:" : (i.gout == "b" ? "拒收时间:" : "无") }}</label>
                          <a-radio-group v-model='i.gout' :disabled='openEdit' size='small' style="white-space:nowrap;"
                            v-else>
                            <a-radio-button :value="null"
                              style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                            <a-radio-button :value="'a'"
                              style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                            <a-radio-button :value="'b'"
                              style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                          </a-radio-group>
                          <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='i.gout == "a"'
                            :disabled='openEdit' style="width:100%;" />
                          <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                            style="width:100%;" v-if='i.gout == "b"' />
                          <a-input disabled v-if='!i.gout' />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="24">
                      <a-col :span='12'>
                        <a-form-model-item label="收件地址" :prop="'supp.' + index + '.addr'"
                          :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                          <a-input v-model="i.addr" :disabled='openEdit' type="textarea" placeholder="请输入收件地址" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='12'>
                        <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type="textarea" placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </div>

              <div class="licter" v-if='!openEdit'>
                <label>接收材料:</label>
                <div class="rmain">
                  <a href="javascript:void(0);" @click="plusAdd(1, 1)">电子</a>
                  <a href="javascript:void(0);" @click="plusAdd(2, 1)">微信</a>
                  <a href="javascript:void(0);" @click="plusAdd(3, 1)">现场</a>
                  <a href="javascript:void(0);" @click="plusAdd(4, 1)">邮寄</a>
                </div>
              </div>
              <div class="ilikecon" style="margin-top:10px;">
                <div class="ilikebox" v-for='(i, index) in form.accept_file' :key='index'>
                  <div class="likebox" v-if='i.type == 1'>
                    <div class="htit">接收材料：电子
                      <span @click='supdel(index)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="平台名称" :prop="'accept_file.' + index + '.platform'"
                          :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }">
                          <a-input v-model="i.platform" :disabled='openEdit' placeholder="请输入平台名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                          :rules="{ required: true, message: '请选择接收时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span='24'>
                        <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="likebox" v-if='i.type == 2'>
                    <div class="htit">接收材料：微信
                      <span @click='supdel(index)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="对方微信号" :prop="'accept_file.' + index + '.wx'"
                          :rules="{ required: true, message: '请输入对方微信号', trigger: 'blur' }">
                          <a-input v-model="i.wx" :disabled='openEdit' placeholder="请输入对方微信号" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                          :rules="{ required: true, message: '请选择接收时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span='24'>
                        <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="likebox" v-if='i.type == 3'>
                    <div class="htit">
                      接收材料：现场
                      <span @click='supdel(index)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.submiter'"
                          :rules="{ required: true, message: '请输入接收人', trigger: 'blur' }">
                          <a-input v-model="i.submiter" :disabled='openEdit' placeholder="请输入接收人" />
                        </a-form-model-item>
                      </a-col>

                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                          :rules="{ required: true, message: '请选择接收时间', trigger: 'change' }">
                          <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col :span='24'>
                        <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="likebox" v-if='i.type == 4'>
                    <div class="htit">
                      接收材料：邮寄
                      <span @click='supdel(index)' v-if='!openEdit'>
                        <a-icon type="minus-circle" />
                      </span>
                    </div>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="单号" :prop="'accept_file.' + index + '.ship_no'"
                          :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                          <a-input v-model="i.ship_no" :disabled='openEdit' placeholder="请输入单号" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' placeholder="请输入" />
                      </a-form-model-item> -->
                        <a-form-model-item label="联系方式" :prop="'accept_file.' + index + '.tel'"
                          :rules="{ required: true, message: '请输入联系方式', trigger: 'blur' }">
                          <a-input v-model="i.tel" :disabled='openEdit' placeholder="请输入联系方式" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                          :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                          <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="24">
                      <a-col :span='8'>
                        <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.receive_name'"
                          :rules="{ required: true, message: '请输入接收人', trigger: 'blur' }">
                          <a-input v-model="i.receive_name" :disabled='openEdit' placeholder="请输入接收人" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="寄出时间" :prop="'accept_file.' + index + '.ship_time'"
                          :rules="{ required: true, message: '请选择寄出时间', trigger: 'change' }">
                          <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                            style="width:100%;" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='8'>
                        <a-form-model-item label="">
                          <label v-if='openEdit'>{{ i.gout == "a" ? "签收时间" : (i.gout == "b" ? "拒收时间" : "无") }}</label>
                          <a-radio-group v-model='i.gout' :disabled='openEdit' size='small' style="white-space:nowrap;"
                            v-else>
                            <a-radio-button :value="null"
                              style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                            <a-radio-button :value="'a'"
                              style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                            <a-radio-button :value="'b'"
                              style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                          </a-radio-group>
                          <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='i.gout == "a"'
                            :disabled='openEdit' style="width:100%;" />
                          <a-date-picker v-model="i.return_time" placeholder="请选择" show-time
                            valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                            style="width:100%;" v-if='i.gout == "b"' />
                          <a-input disabled v-if='!i.gout' />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="24">
                      <a-col :span='12'>
                        <a-form-model-item label="收件地址" :prop="'accept_file.' + index + '.addr'"
                          :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                          <a-input v-model="i.addr" :disabled='openEdit' type="textarea" placeholder="请输入收件地址" />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span='12'>
                        <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                          <a-input v-model="i.comment" :disabled='openEdit' type="textarea" placeholder="请输入备注" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </div>
            </div>
            <a-form-model-item :wrapper-col="{ span: 24 }" :rules="{
              required: false,
              message: '请上传附件',
              trigger: 'change',
            }">
              <Upload @isDisabled="parentHandle" :fList="List" @upFileAfter="
                (element) => {
                  form.files = element
                }
              " :disabled="openEdit" v-if="!loading" :edit="openEdit" />
            </a-form-model-item>
          </div>
          <a-form-model-item :wrapper-col="{ span: 24 }" v-if="!openEdit" style="text-align: center">
            <a-popconfirm :disabled="disabledShow" title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button :disabled="disabledShow" type="primary" style="width: 148px"> 提交 </a-button>
            </a-popconfirm>
            <a-button style="
                margin-left: 20px;
                width: 148px;
                background: #b2c9e1;
                color: #fff;
              " @click="reset">取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
      <!-- <See></See> -->
    </drag-modal>
  </div>
</template>
<script>
import Nscroll from '@/components/nscroll'
import Upload from '@/components/uploads'
import { mapGetters, mapActions } from 'vuex'
import { cpwsAdd, cpwsEdit, cpwsList, delJd } from '@/server/speed'
import Textarea from '@/components/textarea'
const FormItem = [
  {
    type: 1,
    judgment_valid_time: null,
    ship_no: null,
    time: null,
    filename: null,
    disabled: false,
    receive_time: null,
    content: [{ content: '' }],
  },
  {
    type: 2,
    judgment_valid_time: null,
    ship_no: null,
    time: null,
    filename: null,
    disabled: false,
    receive_time: null,
    content: [{ content: '' }],
  },
  {
    type: 5,
    judgment_valid_time: null,
    ship_no: null,
    time: null,
    filename: null,
    disabled: false,
    receive_time: null,
    content: [{ content: '' }],
  },
  {
    type: 3,
    judgment_valid_time: null,
    ship_no: null,
    time: null,
    filename: null,
    disabled: false,
    receive_time: null,
    content: [{ content: '' }],
  },
]

export default {
  name: 'Six',
  computed: {
    ...mapGetters(['litetit', 'Edit']),
  },
  components: {
    Upload,
    Nscroll,
    Textarea,
  },
  created() {
    if (this.Edit) {
      this.$nextTick(() => {
        cpwsList({
          cause_id: this.$store.state.cause.id,
          step: this.$store.state.StepLite,
        }).then((e) => {
          let newList = JSON.parse(JSON.stringify(e.list))
          // newList.map((ele) => {
          //   var newItem = JSON.parse(JSON.stringify(FormItem))
          //   for (let value of newItem) {
          //     ele.cpws.map((element) => {
          //       this.form.accept_file = element.accept_file
          //       this.form.supp = element.supp
          //       this.form.id = element.id
          //       //  element.content = JSON.stringify(element.content) == "{}" ? [{ content: '' }] : Object.keys(element.content).map(key => element.content[key]);
          //       element.content = element.content.length == 0 ? [{}] : element.content
          //       // if (value.type == element.type) {
          //       //   value.id = element.id
          //       //   value.time = element.time
          //       //   value.receive_time = element.receive_time
          //       //   value.judgment_valid_time = element.judgment_valid_time
          //       //   value.ship_no = element.ship_no
          //       //   value.filename = element.filename
          //       //   value.disabled = true
          //       //   value.content = element.content
          //       // }

          //     })
          //   }
          //   ele.cpws = newItem
          // })
          newList.map(ele => {
            ele.cpws.map((element) => {
              element.content = JSON.stringify(element.content) == "[]" ? [{ content: '' }] : element.content
              if (JSON.stringify(element.supp) == '{}') {
                element.supp = []
              } else {
                let s = []
                Object.keys(element.supp).map((ele) => {
                  if (element.supp[ele].type == 4) {
                    element.supp[ele].gout = !element.supp[ele].receive_time &&
                      !element.supp[ele].return_time ?
                      null :
                      element.supp[ele].receive_time ?
                        'a' :
                        'b'
                  }
                  s.push(element.supp[ele])
                })
                element.supp = s
              }
              if (JSON.stringify(element.accept_file) == '{}') {
                element.accept_file = []
              } else {
                let s = []
                Object.keys(element.accept_file).map((ele) => {
                  if (element.accept_file[ele].type == 4) {
                    element.accept_file[ele].gout = !element.accept_file[ele].receive_time &&
                      !element.accept_file[ele].return_time ?
                      null :
                      element.accept_file[ele].receive_time ?
                        'a' :
                        'b'
                  }
                  s.push(element.accept_file[ele])
                })
                element.accept_file = s
              }
            })
          })
          if (e.list[0].cpws.length > 0) {
            this.$store.dispatch("settime", e.list[0].cpws[0].update_time)
          }
          this.Infokey({ key: 'infoList', value: newList })
          this.see(0)
          this.openEdit = true
        })
      })
    } else {
      //  this.form.list[0].disabled = true
      this.loading = false
    }
  },
  data() {
    return {
      List: [],
      step: this.$store.state.StepLite,
      isAllDis: this.$route.query.t,
      rules: {},
      loading: true,
      openEdit: false,
      form: {
        type: 1,
        accept_file: [],
        supp: [],
        files: [],
        judgment_valid_time: null,
        ship_no: null,
        time: null,
        filename: null,
        receive_time: null,
        content: [{ content: '' }],
      },
      disabledShow: false
    }
  },
  filters: {
    rClaTit(type) {
      return {
        1: '判决书',
        2: '调解书',
        3: '其他裁定',
        4: '调解协议',
        5: '撤诉裁定',
        6: '司法确认',
        7: '公证文书',
        8: '撤回申请',
        9: '退回文书',
        10: '其他文书'
      }[type]
    },
  },
  methods: {
    parentHandle(data) {
      this.disabledShow = data
    },
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove',
    }),
    // mustPlusAdd(e) {
    //   let index = e.target.value
    //   let list = JSON.parse(JSON.stringify(this.form.list))
    //   list.map((ele) => {
    //     ele.disabled = false
    //   })
    //   list[index].disabled = !list[index].disabled
    //   this.form.list = list;
    // },
    plusAdd(type, lite) {
      let smForm = {
        type: type,
      }
      if (type == 4) {
        smForm.gout = null
      }
      if (lite) {
        this.form.accept_file.push(smForm)
      } else {
        this.form.supp.push(smForm)
      }
    },
    del(index) {
      let supp = JSON.parse(JSON.stringify(this.form.supp))
      supp.splice(index, 1)
      this.form.supp = supp
    },
    supdel(index) {
      let supp = JSON.parse(JSON.stringify(this.form.accept_file))
      supp.splice(index, 1)
      this.form.accept_file = supp
    },
    delStep() {
      let curIndex = this.$store.state.DisForm.curIndex
      let step_id = this.$store.state.DisForm.infoList[curIndex].id
      delJd({ step_id: step_id }).then(e => {
        this.$message.success("已提交审核")
        setTimeout(e => {
          window.history.go(0)
        }, 500)
      })
    },
    async copydel(index) {
      //删除进度
      await this.Newdel({
        index: index,
        formKey: [
          'type',
          'time',
          'judgment_valid_time',
          'content',
          'disabled',
          'receive_time',
          'ship_no',
          'filename',
        ],
        valkey: 'cpws',
      }).then((e) => {
        this.form.list = JSON.parse(JSON.stringify(e.list))
        this.form.files = []
        this.loading = false
      })
    },
    confirm() {
      this.$refs.forms.validate((valid) => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form))

          if (form.files && form.files.length > 0) {
            form.files = form.files.map((ele) => {
              return ele.upload_id || ele
            })
          }
          // let list = form.list.filter((ele) => {
          //   return ele.disabled
          // })

          // list.map((ele) => {
          //   if (!ele.content[0].content) {
          //     delete ele.content
          //   }
          //   if (!ele.time) {
          //     delete ele.time
          //   }
          //   delete ele.disabled
          // })
          // Object.keys(list[0]).map(key => {
          //   form[key] = list[0][key]
          // })
          // delete form.list
          let curIndex = this.$store.state.DisForm.curIndex
          let isEditCopyAdd =
            this.$store.state.DisForm.copyIndex.indexOf(curIndex) >= 0
              ? true
              : false //当前是否是在修改下的新增
          if (this.Edit && !isEditCopyAdd) {
            //修改
            // let step_id = this.$store.state.DisForm.infoList[curIndex].id

            cpwsEdit(form).then((e) => {
              this.$message.success({ content: '修改成功', key: 'updatable' })
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          } else {
            form.cause_id = this.$store.state.cause.id
            form.step = this.$store.state.StepLite
            cpwsAdd(form).then((e) => {
              this.$message.success({ content: '新增成功', key: 'updatable' })
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    copyNew() {
      //新增复制进度
      this.loading = true
      let copyItem = {
        cause_id: null,
        id: null,
        cpws: [JSON.parse(JSON.stringify(FormItem))],
        title: this.litetit,
      }
      this.addNew(copyItem).then((index) => {
        let list = JSON.parse(JSON.stringify(FormItem))
        list[0].disabled = true
        this.form.list = list
        this.form.files = []
        this.loading = false
      })
    },

    async see(index) {
      //查看切换 审批
      this.loading = true
      this.seeInfo({
        index: index,
        formKey: [
          //  'files',
          'id',
          'accept_file',
          'supp',
          'type',
          'time',
          'judgment_valid_time',
          'content',
          'disabled',
          'receive_time',
          'ship_no',
          'filename',
        ],
        valkey: 'cpws',
      }).then((e) => {
        this.form = e.list[0]
        this.form.files = JSON.parse(JSON.stringify(e.files))
        this.form.files.map((ele) => {
          ele.title = ele.origin_name || ele.title
          ele.upload_id = ele.upload_id
          ele.id = ele.id
        })
        this.List = this.form.files
        this.loading = false
      })
    },
    reset() {
      this.reMove().then((e) => {
        this.$refs.forms.resetFields()
        this.$store.dispatch('openkey', { key: 'Six', by: false })
      })
    },
  },
}
</script>
<style lang="less" scoped>
.mr20 {
  margin-right: 20px;
}

.fourlist {
  // overflow: auto;
  // height: 500px;
  margin-bottom: 20px;
}

.ilikecon {
  max-height: 400px;
  overflow-y: auto;
}

.likebox {
  padding: 20px;
  background: #f3f6fb;
  margin-bottom: 10px;
  border-radius: 8px;

  .htit {
    font-size: 1rem;
    color: #0e2949;
    line-height: 19px;
    margin-bottom: 12px;

    span {
      color: #f00;
      cursor: pointer;
    }
  }

  /deep/ .ant-form-item {
    margin-bottom: 0;
  }

  /deep/ .ant-form-item-label {
    text-align: left;
  }
}

.licter {
  overflow: hidden;
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  label {
    float: left;
    font-size: 0.875rem;
    text-align: right;
    color: #333;
    line-height: 30px;
    margin-right: 10px;
  }

  .clearbtn {
    float: left;
  }

  .rmain {
    // padding-left: 20px;
    // margin-left: 20px;
    float: left;

    a {
      width: 68px;
      line-height: 36px;
      background: #b2c9e1;
      border-radius: 4px;
      display: inline-block;
      margin-right: 20px;
      font-size: 0.875rem;
      color: #fff;
      text-align: center;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
      }
    }
  }
}

.htit {
  font-size: 1rem;
  color: #333;
  line-height: 40px;
  margin: 10px 0;
}

.cmainbox {
  overflow: auto;
  max-height: 500px;
}

/deep/ .ant-form-item {
  margin-bottom: 12px;
}

.dul {
  background: #f3f6fb;
  margin-bottom: 20px;

  .li {
    .tipt {
      font-size: 1rem;
      font-weight: 500;
      color: #0e2949;
    }

    border-radius: 4px;
    padding: 10px 30px 0 20px;

    .input {
      width: 32%;
    }

    .tipt {
      display: block;
      line-height: 40px;
    }
  }
}

.morebar {
  display: flex;
  margin-bottom: 10px;
  height: 40px;
  align-items: center;

  &:nth-last-child(1) {
    margin-bottom: 0;
  }
}

.nwrap {
  display: flex;

  .col {
    width: 280px;

    /deep/ .ant-row {
      display: flex;
    }

    /deep/ .ant-form-item-label {
      width: 72px;
    }
  }
}

.btns {
  width: 5%;
  display: flex;
  font-size: 1.25rem;
  justify-content: space-between;
  padding-right: 20px;
  height: 40px;
  align-items: center;

  .i {
    cursor: pointer;
  }

  .add {
    color: #118afc;
  }

  .del {
    color: #f00;
  }
}
</style>
